import React from 'react';
import { useData } from '../context/DataContext';
import styles from './Marquee.module.css';

export default function Marquee() {
  const { settings } = useData();
  const items = settings.marqueeItems || ['ART YOU CARRY', 'X HAUS', 'HOUSE OF LINE', 'CRAFTED WITH ART', 'X HAUS RULES', 'ESKİŞEHİR'];
  const doubled = [...items, ...items];
  return (
    <div className={styles.strip}>
      <div className={styles.inner}>
        {doubled.map((item, i) => (
          <React.Fragment key={i}>
            <span>{item}</span>
            <span className={styles.dot}>✕</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
